import UserSelectBox from "../user/UserSelectBox";
import {useEffect, useRef, useState} from "react";
import ApiService from "../../core/service/api-service";
import {Button, InputNumber, Table, Tooltip, Typography} from "antd";
import {t} from 'i18next'
import {DeleteOutlined} from "@ant-design/icons";
import {v4} from "uuid";

// Hastanenin imza doktoru havuzu. Artık tek bir "varsayılan" doktor yok: raporlar havuzdaki
// doktorlara PAYLARA göre dağıtılıyor (bkz. SignUserService). Payları ayarlayabilmek için
// gerçekleşen dağılımın da görünmesi gerekiyor, o yüzden atanan sayıları yanında gösteriliyor.
//
// "Atanan" çekim sayar, rapor değil; ama bir çekimin raporlarını iki ayrı hekim imzaladıysa
// İKİSİNİN de sayısı artar. Payı 0 olan doktor dağıtıma hiç girmez, yine de bu listede olduğu
// için kendi okuduğu çekimi kendi adına imzalar ve o çekim burada ona sayılır.
export default function HospitalDoctors({hospitalId, onSave}) {
    const [data, setData] = useState([])
    const [distribution, setDistribution] = useState(null)
    const users = useRef([])

    const getDoctors = async () => {
        const res = await ApiService.UserManager.GetDoctorsOfHospital(hospitalId)
        if(res.success) {
            setData(res.data)
        }
    }

    const getDistribution = async () => {
        const res = await ApiService.UserManager.GetSignDistribution(hospitalId)
        if(res.success) {
            setDistribution(res.data)
        }
    }

    useEffect(() => {
        getDoctors()
        getDistribution()
    }, []);

    const assignedOf = (userId) =>
        distribution?.items?.find(x => x.userId === userId)?.assigned ?? 0

    const totalWeight = data.reduce((sum, x) => sum + (x.weight || 0), 0)

    const setWeight = (id, weight) => {
        const item = data.find(x => x.id === id)
        if(item) {
            item.weight = weight ?? 0
            setData([...data])
        }
    }

    return (
        <>
            <UserSelectBox
                type={'read'}
                style={{width:300, marginBottom: 8}}
                onUsers={(_users) => users.current = _users}
                onChange={(val) => {
                    const user = users.current.find(x => x.id === val);
                    if(user && !data.find(x => x?.user?.id === val)) {
                        setData([
                            ...data,
                            {
                                id: v4(),
                                user,
                                isDefault: false,
                                // Yeni doktor payı 0 ile gelir: dağıtım ancak elle pay verilince
                                // değişsin. Küçük bir varsayılan (1 gibi) yapılandırılmış görünür
                                // ama pratikte hiç rapor almaz, bu daha yanıltıcı olurdu.
                                weight: 0
                            }
                        ])
                    }
                }}
                placeholder={'Select Doctor'}
            />
            <Table
                size={'small'}
                pagination={false}
                dataSource={data}
                rowKey={'id'}
                columns={[
                    {
                        title: t('Name'),
                        key: 'name',
                        dataIndex: 'name',
                        render: (text, record) => record?.user?.visibleName
                    },
                    {
                        title: t('Sign Share'),
                        key: 'weight',
                        dataIndex: 'weight',
                        width: 160,
                        render: (text, record) => (
                            <>
                                <InputNumber
                                    min={0}
                                    max={100}
                                    step={1}
                                    style={{width: 80}}
                                    value={record.weight ?? 0}
                                    onChange={(val) => setWeight(record.id, val)}
                                />
                                <Typography.Text type={'secondary'} style={{marginLeft: 8}}>
                                    {totalWeight > 0 && record.weight > 0
                                        ? `%${Math.round((record.weight / totalWeight) * 100)}`
                                        : '—'}
                                </Typography.Text>
                            </>
                        )
                    },
                    {
                        title: t('Assigned'),
                        key: 'assigned',
                        dataIndex: 'assigned',
                        width: 100,
                        render: (text, record) => assignedOf(record?.user?.id)
                    },
                    {
                        title: t('#'),
                        key: '#',
                        dataIndex: '#',
                        render: (text, record) => (
                            <>
                                <Button
                                    icon={<DeleteOutlined />}
                                    onClick={() => {
                                        const _data = data.filter(x => x.id !== record.id)
                                        setData(_data)
                                    }}
                                />
                            </>
                        )
                    },
                ]}
            />

            {
                distribution?.periodStart && (
                    <Typography.Paragraph type={'secondary'} style={{marginTop: 8, marginBottom: 8}}>
                        <Tooltip title={t('Counting restarts when the pool or a share changes, and never reaches back before today.')}>
                            {t('Distribution period start')}: {new Date(distribution.periodStart).toLocaleString()}
                        </Tooltip>
                    </Typography.Paragraph>
                )
            }

            <Button
                type={'primary'}
                onClick={() => {
                    onSave && onSave(data)
                }}
            >
                {t('Save')}
            </Button>
        </>
    )
}
